<lgb-header-gradient [height]="100" [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	@if(cardBinder()){
		<lgb-back name="collect-card" [params]="[cardBinder().ident]"></lgb-back>
		<p class="title-xs font-serra mt-4 mb-1">Vérifier la carte</p>
		<p class="opacity-60 mb-4">Corrige l'identification si besoin</p>

		<!-- comparaison -->
		<div class="compare-container">
			<div class="flex w-full">
			  <!-- carte originale -->
			  <div class="shadow-sm card bg-base-200 p-2 grid grow place-items-center">
			  	<img hSkeleton="200px" class="img-card-binder" [src]="binderS.getImgInventory(cardBinder().img)"/>
			  </div>

			  <!-- fleche -->
			  <div class="divider divider-horizontal">
			  		<i class="text-primary -rotate-90 fa-solid fa-arrow-down-from-dotted-line"></i>
			  		@if(topSelected().score){
			    		<span class="badge badge-soft badge-primary">
			    			{{topSelected().score | number:'1.3-3':'fr-FR' }}%
			    		</span>
			    	}
			  </div>

			  <!-- Carte de référence -->
			  <div class="card grid grow place-items-center">
			  	<img id="selectedSlot" class="img-card-binder" hSkeleton="200px" [altImg]="cardS.getImages(topSelected().card.img)"/>
			  	<div class="bg-base-100 mt-2 card-body shadow-sm">
			  		<p class="text-xs p-2 ref-card-name">
			  			{{name().text}}<br/>
			  			<span class="text-xs opacity-60 tracking-wide mb-1"># {{topSelected().card.numero}}</span><br/>
			  			<span class="logo-container">
			  				<img class="logo-symbol mr-2" [altImg]="[cardSet() | imgSymbol]"/> {{setName()}}
			  			</span>
			  			<!-- Match : {{topSelected().score | number:'1.3-3':'fr-FR' }}% -->
			  		</p>
			  	</div>
			  </div>
			</div>
		</div>

		<div class="card-choice my-4">
			<button (click)="action.set('form')" [ngClass]="{'btn-primary': action()=='form', 'text-primary': action()=='match'}" class="text-xs btn">
				<i class="fa-solid fa-check"></i> Exact !
			</button>
		  	<button (click)="action.set('match')" [ngClass]="{'btn-primary': action()!='form', 'text-primary': action()!='match'}" class="text-xs btn text-primary ">
		  		<i class="fa-regular fa-pen"></i> Identifier
		  	</button>
		  	<button (click)="scanS.enable('card', cardBinder().ident)" class="text-xs btn text-primary">
		  		<i class="fa-regular fa-arrows-rotate"></i> Rescanner
		  	</button>
		</div>

		<!-- formulaire  -->
		<div class="fieldset border-base-300 rounded-box border p-4 glass form-container">
			<div [ngClass]="{'mb-4': (error() || msg())}" class="">
				<lgb-message [(error)]="error" [(msg)]="msg"></lgb-message>
			</div>

			<!-- formulaire modification de la carte -->
			<div [ngClass]="{hidden: action()!='form'}">
				<lgb-update-card [card]="cardBinder()" (update)="updateCard()"></lgb-update-card>
			</div>

			<!-- identification de la carte -->
			<div [ngClass]="{hidden: action()!='match'}">
				<lgb-identify-card [topK]="topK()" [(topSelected)]="topSelected" (update)="updateCard()"></lgb-identify-card>
			</div>

			<!-- formulaire d'ajout d'une nouvelle carte -->

		</div>
	}
</div>